import { path } from 'ramda';
import * as search from 'common/store/search/advanced/selectors';

export const getScope = path(['job', 'search']);

const selectors = search.factory(getScope);

export const {
  isExpanded,
  hasCriteria,
  getCriteriaState,
  getCriteria,
  getCount,
  getDSL,
  hasConstraints,
} = selectors;
